import React from 'react'
import { PostPreviewProvider } from 'components/PostPreviewModal/PostPreviewContext'
import { PostPreviewProps } from 'components/PostPreviewModal/Types'
import { PostPreviewContext } from 'components/PostPreviewModal/PostPreviewContext'
import { providerFromChannelType } from 'components/ArticlePostPreview/ArticlePostPreviewContext'
import { PostStatusPropertyValue } from 'api/clients/PropertyClient'
import { PostPreviewStoreProvider } from './PostPreviewStoreProvider'

type ProvidersProps = React.PropsWithChildren<PostPreviewProps>

export const PostPreviewProviders = ({ children, ...props }: ProvidersProps) => (
  <PostPreviewProvider {...props}>
    <PostPreviewContext.Consumer>
      {(context) => {
        if (!context) return null
        const { fileId, dateTime, scheduledPost, status } = context
        const provider = providerFromChannelType[props.channel]

        const postAt =
          dateTime && dateTime.isValid && dateTime.isValid() ? dateTime.toISOString() : new Date().toISOString()
        const existingScheduled =
          fileId && provider
            ? {
                fileId,
                postAt,
                provider,
                externalIntegration: scheduledPost?.external_integration,
                status: status ?? PostStatusPropertyValue.Draft,
              }
            : undefined
        return (
          <PostPreviewStoreProvider
            {...props}
            existingScheduledInfo={props.isExistingFile ? existingScheduled : undefined}
          >
            {children}
          </PostPreviewStoreProvider>
        )
      }}
    </PostPreviewContext.Consumer>
  </PostPreviewProvider>
)
